import NetworkingOperations from "../index";

const GetPDF = (data) => {
	const url = process.env.REACT_APP_GET_PDF;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default GetPDF;
